import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleSettingPopup, setDefaultSettingTabId } from "store/actions/app";
import {
  selectCamera,
  selectSpeaker,
  selectMicrophone,
  setMirrorSelfView,
} from "store/actions/devices";
import { test, sortDevices } from "utils/helpers";
import { useSystemDefaultName } from "utils/hooks";
import { useTranslation } from "react-i18next";
import { isSafari } from "react-device-detect";
import { useEffect } from "react";
import * as googleAnalytics from "store/actions/googleAnalytics";
import storage from "utils/storage";
import { isMobile } from "react-device-detect";
import { getIsBackgroundEffectSupported } from "utils/useBackgroundEffect";
import useBanubaTokenValid from "utils/hooks";
const DeviceMenuList = ({ deviceType, menuHeader, showPopup }) => {
  const devices = useSelector((state) => state.devices[deviceType + "s"]);
  const mirrorSelfView = useSelector(
    (state) => state.devices["mirrorSelfView"]
  );
  const sortedDevices = sortDevices(devices);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isBanubaTokenValid] = useBanubaTokenValid();
  const processName = useSystemDefaultName();
  const showDefaultOutputMessage =
    deviceType === "speaker" && sortedDevices.length === 1 && isSafari;
  const onItemSelect = useCallback(
    (localDevice) => {
      if (localDevice.selected) return;

      switch (deviceType) {
        case "microphone":
          dispatch(selectMicrophone(localDevice));
          break;
        case "camera":
          dispatch(selectCamera(localDevice));
          break;
        case "speaker":
          dispatch(selectSpeaker(localDevice));
          break;
        default:
          break;
      }
    },
    [dispatch, deviceType]
  );

  const menuItem = (item) => {
    return (
      <div
        tabIndex="0"
        aria-selected={item.selected ? "true" : "false"}
        role="option"
        className={`menu-item ${deviceType}-item ${
          item.selected ? "selected" : ""
        }`}
        onClick={() => onItemSelect(item)}
        key={item.id}
        {...test(`SELECT_${deviceType.toUpperCase()}_ITEM`)}
      >
        <span>{processName(item)}</span>
      </div>
    );
  };

  const deviceList = (devices) => {
    return (
      <div className="device-list">
        {devices.map((deviceItem) => menuItem(deviceItem))}
      </div>
    );
  };
  const mirrorSelfViewOption = () => {
    return (
      <>
        {deviceType === "camera" && (
          <div className="device-options-list">
            <div
              tabIndex="0"
              aria-selected={mirrorSelfView ? "true" : "false"}
              role="option"
              className={`menu-item ${deviceType}-item ${
                mirrorSelfView ? "selected" : ""
              }`}
              onClick={() => {
                storage.addItem("mirrorSelfView", !mirrorSelfView);
                dispatch(setMirrorSelfView(!mirrorSelfView));
                dispatch(googleAnalytics.mirrorSelfViewClick("dropDown"));
              }}
              {...test(`SELECT_MIRROR_SELF_VIEW`)}
            >
              <span>{t("MIRROR_SELF_VIEW")}</span>
            </div>
          </div>
        )}
      </>
    );
  };
  const customizeBackground = () => {
    return (
      <>
        {deviceType === "camera" && (
          <div className="device-options-list no-border">
            <div
              tabIndex="0"
              aria-selected={"true"}
              role="option"
              className={`menu-item ${deviceType}-item`}
              onClick={() => {
                dispatch(toggleSettingPopup(false));
                dispatch(setDefaultSettingTabId("media"));
                showPopup(false);
              }}
            >
              <span>{t("CUSTOMIZE_BACKGROUND")}</span>
            </div>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    document.querySelector(".device-list-menu-header")?.focus();
  }, []);

  return (
    <div
      className={`device-list-menu ${deviceType}-select-menu`}
      {...test(`${deviceType}-select-menu`)}
    >
      <div tabIndex="-1" className="device-list-menu-header">
        {menuHeader}
      </div>
      {deviceList(sortedDevices)}
      {mirrorSelfViewOption()}
      {showDefaultOutputMessage && (
        <div
          className="default-device-message"
          {...test(`DEFAULT_OUTPUT_MESSAGE`)}
        >
          {t("BROWSER_USES_DEFAULT_DEVICES_MESSAGE")}
        </div>
      )}
      {((isMobile && isBanubaTokenValid !== false) || isBanubaTokenValid) &&
        getIsBackgroundEffectSupported() &&
        customizeBackground()}
    </div>
  );
};

export default DeviceMenuList;
